import { AutoMap } from "@automapper/classes";
import { CoreData } from "../tools/core-data/core-data";
import { Client } from "./client";
import { LimitCategory } from "./limit-category";
import { ProductGroup } from "./product-group"

export class Configuration {
    public constructor(init?: Partial<Configuration>) {
        Object.assign(this, init);
    }
    @AutoMap()
    Name: string = '';

    @AutoMap()
    Code: string = '';
    @AutoMap()
    IsActive: boolean = false;
    @AutoMap()
    TestGroupForeColor: string = '';
    @AutoMap()
    TestGroupBackColor: string = '';
    @AutoMap()
    TestForeColor: string = '';
    @AutoMap()
    TestBackColor: string = '';
    @AutoMap()
    DisplayEmptyGroups: boolean = false;
    @AutoMap()
    DisplayEmptyTests: boolean = false; 
    @AutoMap()
    IsMaster: boolean = false;
    @AutoMap()
    ExportNote: string = '';  
    @AutoMap()
    DisplayComparateurLQ: boolean = false;
    @AutoMap()
    DisplayDND: boolean = false;
    @AutoMap()
    CreatedOn?: Date
    @AutoMap()
    ModifiedOn?: Date
    @AutoMap()
    CreatedByEmail: string = '';
    @AutoMap()
    ModifiedByEmail: string = '';
    @AutoMap()

    UseComaAsDecimalSeparator: boolean = false
    @AutoMap()
    OutOfLimitFontBold: boolean = false
    @AutoMap()
    OutOfLimitFontItalic: boolean = false
    @AutoMap()
    UseLeftMostLimit: boolean = true;
    @AutoMap()
    WithParameterCodeColumn: boolean = false;
    @AutoMap()
    WithCASNumberColumn: boolean = false;
    @AutoMap()
    WithLOQColumn: boolean = false;
    @AutoMap()
    WithMethodColumn: boolean = false;
    @AutoMap()
    WithLOQIncertitudeColumn: boolean = false;
    @AutoMap()
    WithBarcodeRow: boolean = false;
    @AutoMap()
    WithPSVNameRow: boolean = false;
    @AutoMap()
    HasBilanConformite: boolean = false;
    Logo?: File;
    LogoToBase64: string = '';

    @AutoMap(() => [LimitCategory])
    LimitCategoryList: LimitCategory[] = [];
    @AutoMap(() => [ProductGroup])
    ProductGroupList: ProductGroup[] = [];
    /**
     * Only for Master Configuration
     */
    @AutoMap(() => [Client])
    ClientList: Client[] = [];

    get IsPublic() {
        return this.ClientList.length === 0
    }

}